import { useEffect } from 'react';
import { X } from 'lucide-react';
import { classNames } from '../../utils/classNames';

function Modal({ open, onClose, title, description, children, footer, size = 'md', panelClassName }) {
  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = (event) => event.key === 'Escape' && onClose();
    document.addEventListener('keydown', handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;
  const sizes = { sm: 'max-w-sm', md: 'max-w-lg', lg: 'max-w-2xl' };
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto p-3 sm:items-center sm:p-4" role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <button className="absolute inset-0 bg-slate-950/55 backdrop-blur-sm" onClick={onClose} aria-label="Cerrar modal" />
      <div className={classNames('relative my-2 flex max-h-[calc(100svh-1.5rem)] w-full shrink-0 flex-col overflow-hidden rounded-panel border bg-white shadow-elevated sm:my-0 sm:max-h-[calc(100svh-2rem)]', sizes[size], panelClassName)}>
        <header className="flex shrink-0 items-start justify-between gap-4 border-b px-4 py-3 sm:px-5 sm:py-4">
          <div>
            <h2 id="modal-title" className="font-semibold text-content-primary">{title}</h2>
            {description && <p className="mt-1 text-sm text-content-muted">{description}</p>}
          </div>
          <button onClick={onClose} className="rounded-md p-1.5 text-content-muted hover:bg-slate-100 hover:text-content-primary" aria-label="Cerrar">
            <X className="size-5" />
          </button>
        </header>
        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain p-4 sm:p-5">{children}</div>
        {footer && <footer className="flex shrink-0 flex-wrap justify-end gap-2 border-t bg-slate-50 px-4 py-3 sm:gap-3 sm:px-5 sm:py-4">{footer}</footer>}
      </div>
    </div>
  );
}

export default Modal;
